<template>
  <div>
    <div class="ts-flex ts-mb-2 ts-justify-between ts-items-center">
      <div class="ts-flex">
        <ts-checkbox v-model="academic_status" :value="1">{{
          $t('invoice.current')
        }}</ts-checkbox>
        <ts-checkbox
          class="ts-ml-3 ts-mr-3"
          v-model="academic_status"
          :value="3"
          >{{ $t('invoice.next') }}</ts-checkbox
        >
        <ts-checkbox
          @change="fetchStudentList"
          v-model="academic_status"
          :value="2"
          >{{ $t('invoice.history') }}</ts-checkbox
        >
      </div>
      <div class="ts-flex ts-space-x-2">
        <a
          href="#"
          class="
          ts-px-3 ts-py-1 ts-bg-blue-800 
          ts-text-white ts-rounded hover:ts-text-white"
          v-tooltip="$t('invoice.newStudent')"
          @click.prevent="showNewStudent"
        >
          <i class="fas fa-user-graduate"></i>
        </a>
        <!-- <a
          href="#"
          class="ts-px-3 ts-py-1 ts-bg-blue-800 ts-text-white ts-rounded hover:ts-text-white"
          v-tooltip="$t('invoice.notYetEnrollment')"
        >
          <i class="fas fa-users"></i>
        </a> -->
      </div>
    </div>
    <div id="container-table">
      <ts-loading-banner :loading="getting_student">
        <table class="table table-hover ui-table">
          <thead>
            <tr>
              <th>{{ $t('invoice.student') }}</th>
              <th>{{ $t('invoice.academicInfo') }}</th>
              <th class="text-left">{{ $t('invoice.teacherName') }}</th>
            </tr>
            <tr>
              <th colspan="5">
                <input
                  v-model="search"
                  type="text"
                  class="form-control"
                  :placeholder="$t('invoice.typeSearch')"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(student, index) in student_resources"
              :key="index"
              @dblclick="selectedStudent(student)"
            >
              <!-- v-tooltip="$t('invoice.dbClickStudentCreateRecord')" -->
              <td>
                <p class="text-primary" v-tooltip="$t('invoice.studentName')">
                  <i class="fa fa-user mr-2"></i>
                  <strong>{{ student.student_profile.full_name_en }}</strong>
                </p>
                <p v-tooltip="$t('invoice.studentId')">
                  <i class="far fa-id-card mr-2"></i>
                  {{ student.student_profile.card_number }}
                </p>
                <p
                  v-if="student.student_profile.phone"
                  v-tooltip="$t('invoice.phoneNumber')"
                >
                  <i class="fa fa-phone mr-2"></i>
                  {{ student.student_profile.phone }}
                </p>
                <p v-tooltip="$t('invoice.sex')">
                  <i class="fa fa-venus-mars mr-2"></i>
                  {{ student.student_profile.gender }}
                </p>
              </td>
              <td>
                <p v-tooltip="$t('invoice.subProgram')">
                  <i class="fa fa-book-open mr-2"></i>
                  {{ student.academic_class.sub_program.acps_name_foreign }}
                </p>
                <p v-tooltip="$t('invoice.className') +' '+ $t('invoice.grade')" class="text-primary">
                  <i class="fa fa-layer-group mr-2"></i>
                  {{ student.academic_class.class_name + ' (' + student.academic_class.grade.grade_name_foreign  + ')'}}
                </p>
                <p class="text-info">
                  <i class="fas fa-sort-numeric-up mr-2"></i>
                  {{ student.academic_class.room.room_name }}
                </p>
                <p v-tooltip="$t('invoice.studyTime')" class="text-warning">
                  <i class="fa fa-clock mr-2"></i>
                  <span>
                    {{ student.academic_class.academic_study_time.study_time }}
                  </span>
                </p>
                <p>
                  <i class="fas fa-cog mr-2"></i>
                  {{ student.academic_class.academic_term.term_name }}
                  <span
                    class="badge badge-success"
                    v-if="student.ac_status_id == 1"
                    >{{ $t('invoice.current') }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="student.ac_status_id == 2"
                    >History</span
                  >
                  <span
                    class="badge badge-warning"
                    v-if="student.ac_status_id == 3"
                    >{{ $t('invoice.next') }}</span
                  >
                </p>
              </td>
              <td class="text-left" valign="middle">
                <p>
                  <i class="fa fa-chalkboard-teacher mr-2"></i>
                  {{
                    student.academic_class.teacher ? (student.academic_class.teacher.fname_foreign +
                      ' ' +
                      student.academic_class.teacher.lname_foreign) : null
                  }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
    <a-modal
      v-if="show_create_new_student"
      v-model="show_create_new_student"
      :title="$t('invoice.newStudent')"
      :centered="true"
      :footer="null"
      width="700px"
    >
      <CreateNewStudent 
        @student="selectedStudent"
        @cancel="() => (show_create_new_student = false)"
      />
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
import CreateNewStudent from './create-new-student.vue'

export default {
  name: 'studentList',
  components: {
    CreateNewStudent
  },
  data() {
    return {
      getting_student: false,
      show_create_new_student: false,
      student_resources: [],
      search: null,
      academic_status: [1]
    }
  },
  created() {
    if (this.activeTab == 1) {
      this.fetchStudentList()
    }
  },
  methods: {
    ...mapActions('invoice', ['getStudent']),
    fetchStudentList() {
      if (!this.search) return
      this.getting_student = true
      this.getStudent({
        filter: {
          ac_status_id: _.join(this.academic_status, ','),
          active_student: true
        },
        search: this.search,
        perPage: 100
      })
        .then(response => {
          this.student_resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.getting_student = false
        })
    },
    selectedStudent(student) {
      this.$emit('seleted', student)
    },
    showNewStudent() {
      this.show_create_new_student = true
    }
  },
  watch: {
    search: debounce(function(value) {
      if (value !== null || value !== '') {
        this.fetchStudentList()
      }
      this.student_resources = []
    }, 600),
    academic_status: debounce(function(value) {
      this.fetchStudentList()
    }, 600)
  }
}
</script>

<style lang="css" scoped>
#container-table {
  max-height: 35vh;
  height: 30vh;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  white-space: nowrap;
}

.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /* z-index: 999; */
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  cursor: pointer;
  font-size: 12px;
}
</style>
